import React, { useEffect, useRef, useState } from "react";
import styles from "./AboutMeComponent.module.css";
import { useT } from "../../i18n";

const LINKEDIN = "https://www.linkedin.com/in/danielrayrangel/";

// Credential names stay in their official (English) form on both locales.
const CERTS = [
  { img: "/credly/full-stack-java-react.png", label: "Full-Stack Java + React" },
  { img: "/credly/microsoft-certified-dynamics-365-fundamentals-crm.png", label: "Dynamics 365 Fundamentals" },
  { img: "/credly/microsoft-certified-power-platform-fundamentals.png", label: "Power Platform Fundamentals" },
  { img: "/credly/ai-foundational-skills.png", label: "AI Foundational Skills" },
];

const AboutMeComponent = () => {
  const t = useT().about;
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setInView(true);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      id="about"
      ref={ref}
      className={`${styles.about} ${inView ? styles.inview : ""}`}
    >
      <div className={styles.inner}>
        <p className={styles.eyebrow}>{t.eyebrow}</p>

        <div className={styles.grid}>
          <div className={styles.story}>
            <h2 className={styles.name}>{t.name}</h2>
            <p className={styles.meta}>{t.meta}</p>
            <img
              className={`${styles.logoMark} ${styles.logoMobile}`}
              src="/Exhale.Daniel.Ray.Rangel.png"
              alt=""
              aria-hidden="true"
              width="120"
              height="120"
              loading="lazy"
            />
            <p className={styles.lead}>{t.lead}</p>
            <p className={styles.body}>{t.body1}</p>
            <p className={styles.body}>{t.body2}</p>
            <a
              className={styles.linkedin}
              href={LINKEDIN}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.linkedin}
            </a>
          </div>

          <aside className={styles.cred}>
            <img
              className={`${styles.logoMark} ${styles.logoDesktop}`}
              src="/Exhale.Daniel.Ray.Rangel.png"
              alt="Exhale Software Solutions logo"
              width="130"
              height="130"
              loading="lazy"
            />
            <p className={styles.credLabel}>{t.credLabel}</p>
            <ul className={styles.certGrid}>
              {CERTS.map((c) => (
                <li key={c.img} className={styles.cert}>
                  <img src={c.img} alt={`${c.label} certification badge`} loading="lazy" />
                  <span>{c.label}</span>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default AboutMeComponent;
